import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, List, X } from "react-bootstrap-icons";
import { useLocalize } from "../hooks/useLocalize";
import { profileCopy, type ProfileLanguage } from "../i18n/profile";
import { languagesList } from "../i18n/strings";

export const NavigationItems = () => {
  const { language, setLanguage, localizePath } = useLocalize();
  const copy = profileCopy[language as ProfileLanguage] || profileCopy.en;
  const [open, setOpen] = useState(false);
  const home = localizePath("/");
  return <header className="site-header"><div className="header-inner section-shell">
    <Link className="brand" to={home} onClick={() => setOpen(false)} aria-label="Hasan Uzun"><span className="brand-mark">hu<span>↗</span></span><span>hasan uzun<span className="brand-subtitle">{copy.role}</span></span></Link>
    <button className="menu-toggle" aria-label={copy.services} aria-expanded={open} aria-controls="main-navigation" onClick={() => setOpen(!open)}>{open ? <X /> : <List />}</button>
    <nav id="main-navigation" className={open ? "main-nav is-open" : "main-nav"} aria-label={copy.services}>
      {[["expertise", copy.services], ["approach", copy.approach], ["about", copy.about]].map(([id, label]) => <Link to={`${home}#${id}`} key={id} onClick={() => setOpen(false)}>{label}</Link>)}
      <select className="language-select" aria-label="Language / Sprache / Dil" value={language} onChange={event => setLanguage(event.target.value)}>{languagesList.map(lang => <option value={lang.key} key={lang.key}>{lang.key.toUpperCase()}</option>)}</select>
      <Link className="nav-contact" to={`${home}#contact`} onClick={() => setOpen(false)}>{copy.contact}<ArrowUpRight /></Link>
    </nav>
  </div></header>;
};
